import { Injectable } from '@angular/core';

import { HttpService } from '../http/http.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class ShelfcaseService {
  private apiUrl = '/spring/shelfcases';
  

  constructor(private http: HttpService) { }

  get(): Promise<any> {
    const url = environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiUrl;
    return this.http.get(url);
  }

  post(
    shelfcaseTx: string,
    shelfCd: string,
    caseCd: string,
    layerNr: Number,
    orderNr: Number,
    updprogramCd: string
  ): Promise<any> {
    const url = environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiUrl;

    const jsonInput = {
      shelfcaseTx: shelfcaseTx,
      shelfCd: shelfCd,
      caseCd: caseCd,
      layerNr: layerNr,
      orderNr: orderNr,
      updprogramCd: updprogramCd
    };

    return this.http.post(url, jsonInput);

  }

  put(
    shelfcaseId: Number,
    shelfcaseTx: string,
    layerNr: Number,
    orderNr: Number,
    updprogramCd: string
  ): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiUrl}/${shelfcaseId}`;

    const jsonInput = {
      shelfcaseTx: shelfcaseTx,
      layerNr: layerNr,
      orderNr: orderNr,
      updprogramCd: updprogramCd
    };

    return this.http.put(url, jsonInput);
  }

  delete(shelfcaseId: Number): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiUrl}/${shelfcaseId}`;
    return this.http.delete(url);
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/service/shelfcase/shelfcase.service.ts